import clsx from "clsx";

export const ScrollTabs = ({
  items,
  getCategory,
  selectedCategory,
  className,
  children,
}) => {
  const handleCategoryChange = (category) => {
    getCategory(category);
  };

  return (
    <div className={clsx(className, "overflow-x-auto hidden-scrollbar")}>
      <div
        className={clsx(
          "min-w-fit max-w-[73rem] max-md:max-w-none mx-auto flex items-center px-4",
          children ? "justify-between" : ""
        )}
      >
        <div className="flex items-center gap-2.5 max-lg:pl-4 lg:pl-2 overflow-hidden">
          {items?.map((item, i) => {
            const isActive = selectedCategory === item.value;
            return (
              <div
                key={i}
                onClick={() => handleCategoryChange(item.value)}
                className={clsx(
                  "py-[7px] px-3 rounded-xl cursor-pointer w-max flex items-center justify-center gap-2",
                  !isActive && "border border-neutral50 text-neutral300"
                )}
                style={{
                  backgroundColor: item.bg,
                  ...(isActive && {
                    border: `2px solid ${item.activeColor}`,
                  }),
                }}
              >
                <span
                  className="w-[18px] h-[18px] rounded-full transition-colors"
                  style={{
                    backgroundColor: isActive
                      ? item.activeColor
                      : "transparent",
                    border: isActive
                      ? "none"
                      : `1px solid ${item.activeColor}40`,
                  }}
                />
                <span className="text-[13px] font-medium">{item.name}</span>
              </div>
            );
          })}
        </div>
        {children}
      </div>
    </div>
  );
};
